import "./style.scss";
import { useEffect } from "react";
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";

import { DigitalUniversityOuterCircle } from "@/src/svg/DigitalUniversityOuterCircle";
import DigitalUniversityOuterIconOne from "@/src/assets/HomePage/DigitalUniversity/DigitalUniversityOuterIconOne.png";
import DigitalUniversityOuterIconTwo from "@/src/assets/HomePage/DigitalUniversity/DigitalUniversityOuterIconTwo.png";
import DigitalUniversityOuterIconThree from "@/src/assets/HomePage/DigitalUniversity/DigitalUniversityOuterIconThree.png";
import DigitalUniversityOuterIconFour from "@/src/assets/HomePage/DigitalUniversity/DigitalUniversityOuterIconFour.png";
import DigitalUniversityOuterIconFive from "@/src/assets/HomePage/DigitalUniversity/DigitalUniversityOuterIconFive.png";

import { DigitalUniversityCentralCircle } from "@/src/svg/DigitalUniversityCentralCircle";
import DigitalUniversityCentralIconOne from "@/src/assets/HomePage/DigitalUniversity/DigitalUniversityCentralIconOne.png";

import DigitalUniversityInnerIconOne from "@/src/assets/HomePage/DigitalUniversity/DigitalUniversityInnerIconOne.png";
import DigitalUniversityInnerIconTwo from "@/src/assets/HomePage/DigitalUniversity/DigitalUniversityInnerIconTwo.png";

import DigitalUniversityInnerCircle from "@/src/assets/HomePage/DigitalUniversity/DigitalUniversityInnerCircle.png";
import DigitalUniversityDevicePhone from "@/src/assets/HomePage/DigitalUniversity/DigitalUniversityDevicePhone.png";

const DigitalUniversityAnimation = () => {
  const { ref, inView } = useInView({
    threshold: 0.7,
    triggerOnce: true,
  });

  const outerControls = useAnimation();
  const centralControls = useAnimation();
  const innerControls = useAnimation();
  const phoneControls = useAnimation();
  const phoneMaskControls = useAnimation();

  useEffect(() => {
    if (inView) {
      outerControls.start({ rotate: 360, transition: { duration: 2.5 } });
      centralControls.start({ rotate: -360, transition: { duration: 2.2 } });
      innerControls.start({ rotate: 360, transition: { duration: 2.2 } });
      phoneControls.start({ transform: "translateY(0)", transition: { duration: 3 } });
      phoneMaskControls.start({ transform: "translateY(-7rem)", transition: { duration: 3 } });
    }
  }, [centralControls, inView, innerControls, outerControls, phoneControls, phoneMaskControls]);

  return (
    <div ref={ref} className="digital-university-animation">
      <motion.div className="outer-circle" animate={outerControls}>
        <DigitalUniversityOuterCircle />
        <div className="outer-circle-icon-wrapper one">
          {/* <DigitalUniversityOuterIconOne /> */}
          <img src={DigitalUniversityOuterIconOne} alt="Outer Circle Icon" />
        </div>
        <div className="outer-circle-icon-wrapper two">
          {/* <DigitalUniversityOuterIconTwo /> */}
          <img src={DigitalUniversityOuterIconTwo} alt="Outer Circle Icon" />
        </div>
        <div className="outer-circle-icon-wrapper three">
          {/* <DigitalUniversityOuterIconThree /> */}
          <img src={DigitalUniversityOuterIconThree} alt="Outer Circle Icon" />
        </div>
        <div className="outer-circle-icon-wrapper four">
          {/* <DigitalUniversityOuterIconFour /> */}
          <img src={DigitalUniversityOuterIconFour} alt="Outer Circle Icon" />
        </div>
        <div className="outer-circle-icon-wrapper five">
          {/* <DigitalUniversityOuterIconFive /> */}
          <img src={DigitalUniversityOuterIconFive} alt="Outer Circle Icon" />
        </div>
      </motion.div>

      <motion.div className="central-circle" animate={centralControls}>
        <DigitalUniversityCentralCircle />
        <div className="central-circle-icon-wrapper one">
          {/* <DigitalUniversityCentralIconOne /> */}
          <img src={DigitalUniversityCentralIconOne} alt="Central Circle Icon" />
        </div>
      </motion.div>

      <motion.div className="inner-circle" animate={innerControls}>
        <img src={DigitalUniversityInnerCircle} alt="inner-circle" />
        <div className="inner-circle-icon-wrapper one">
          {/* <DigitalUniversityInnerIconOne /> */}
          <img src={DigitalUniversityInnerIconOne} alt="Inner Circle Icon" />
        </div>
        <div className="inner-circle-icon-wrapper two">
          {/* <DigitalUniversityInnerIconTwo /> */}
          <img src={DigitalUniversityInnerIconTwo} alt="Inner Circle Icon" />
        </div>
      </motion.div>

      <div className="inner-circle-mask-wrapper">
        <div className="device-phone mask">
          <motion.img src={DigitalUniversityDevicePhone} alt="mask phone" animate={phoneMaskControls} />
        </div>
      </div>

      <div className="device-phone">
        <motion.img src={DigitalUniversityDevicePhone} alt="digital-university-device-phone" animate={phoneControls} />
      </div>
    </div>
  );
};
export default DigitalUniversityAnimation;
